import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Alert, Button, Card, Col, Collapse, Icon, Row } from 'antd';
import Payment from './Payment';
import { currencyVND, dateToString } from '../../../../utils';
import { PAYMENT_METHOD } from '../../../../utils/const';

const { Panel } = Collapse;

export default (props) => {

	const [visible, setVisible] = useState(false);

	const { orderDetail, setOrderDetail, setRerender, paymentHistory, setPaymentHistory } = props;

	// useEffect(() => {
	//   setPaymentHistory(orderDetail?.paymentHistoryResponses || [])
	// }, [orderDetail]);

	const InfoRow = ({ label, value, labelSpan = 10, valueSpan = 14 }) => (
		<Row style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
			<Col span={labelSpan}>{label}</Col>
			<Col span={valueSpan}>: {value || '---'}</Col>
		</Row>
	);

	const createHeader = (item) => {
		return <div>
			<Row>
				<Col lg={20}>
					<InfoRow labelSpan={5} label={PAYMENT_METHOD[item.paymentMethod]} value={currencyVND(item.paymentPrice)} />
				</Col>
				<Col lg={4}>{`${dateToString(item.paymentDate)}`}</Col>
			</Row>
		</div>;
	};

	const renderPaymentHistory = () => {
		return paymentHistory.map((item, idx) => {
			return <Panel header={createHeader(item)} key={idx}>
				<InfoRow labelSpan={4} label="Người thanh toán" value={item.paymentUser} />
			</Panel>;
		});
	};

	const renderTitlePaymentInfo = () => {
		if (orderDetail.invoiceRefundId) {
			if (orderDetail.refundAmount < 0) {
				if (orderDetail.status === 'COMPLETED') {
					return 'Đã thanh toán toàn bộ'
				}
				return 'Đơn hàng chờ thanh toán';
			} else {
				if (orderDetail.status === 'COMPLETED') {
					return 'Đã hoàn tiền cho khách'
				}
				return 'Xác nhận hoàn tiền';
			}
		} else {
			return orderDetail.status !== 'COMPLETED' ? 'Đơn hàng chờ thanh toán' : 'Đã thanh toán toàn bộ';
		}
	};

	const renderTitleButtonPayment = () => {
		if (orderDetail.invoiceRefundId) {
			if (orderDetail.refundAmount < 0) {
				return 'Thanh toán';
			} else {
				return 'Xác nhận hoàn tiền';
			}
		} else {
			return 'Thanh toán';
		}
	};

	const renderPaymentInfoDetail = () => {
		if (orderDetail.invoiceRefundId) {
			if (orderDetail.refundAmount < 0) {
				return <Alert
					message={<Row>
						<Col lg={8}>Khách phải trả: <b>{currencyVND((orderDetail?.refundAmount * -1) || 0)}</b></Col>
						<Col lg={8} style={{ textAlign: 'center' }}>Đã thanh
							toán: <b>{currencyVND(orderDetail.paidAmount || 0)}</b></Col>
						<Col lg={8} style={{ textAlign: 'right' }}>Còn phải trả: <b
							style={{ color: 'red' }}>{currencyVND((orderDetail?.refundAmount * -1) - (orderDetail.paidAmount || 0))}</b></Col>
					</Row>}
					type="success"
				/>;
			} else {
				return <Alert
					message={<Row>
						<Col lg={8}>Cần hoàn trả: <b>{currencyVND(orderDetail?.refundAmount || 0)}</b></Col>
						<Col lg={8} style={{ textAlign: 'center' }}>Đã hoàn
							trả: <b>{currencyVND(orderDetail.refundPaidAmount)}</b></Col>
						<Col lg={8} style={{ textAlign: 'right' }}>Còn phải hoàn trả: <b
							style={{ color: 'red' }}>{currencyVND(orderDetail.refundAmount - orderDetail.refundPaidAmount)}</b></Col>
					</Row>}
					type="success"
				/>;
			}
		} else {
			return <Alert
				message={<Row>
					<Col lg={8}>Khách phải trả: <b>{currencyVND(orderDetail?.finalAmount || 0)}</b></Col>
					<Col lg={8} style={{ textAlign: 'center' }}>Đã thanh
						toán: <b>{currencyVND(orderDetail.paidAmount || 0)}</b></Col>
					<Col lg={8} style={{ textAlign: 'right' }}>Còn phải trả: <b
						style={{ color: 'red' }}>{currencyVND((orderDetail?.finalAmount || 0) - (orderDetail.paidAmount || 0))}</b></Col>
				</Row>}
				type="success"
			/>;
		}
	};

	const getRemainsToPaid = () => {
		if (orderDetail.invoiceRefundId) {
			if (orderDetail.refundAmount < 0) {
				return (orderDetail?.refundAmount * -1) - (orderDetail.refundPaidAmount || 0);
			} else {
				return orderDetail.refundAmount - orderDetail.paidAmount;
			}
		} else {
			return orderDetail.finalAmount - orderDetail.paidAmount;
		}
	};

	return (<>
		<Col className={'mt-20'}>
			<Card
				title={<Fragment>
					<Row style={{ display: 'flex', alignItems: 'center' }}>
						<Col lg={20}>
							<Icon type="money-collect"
										theme="twoTone" /> {renderTitlePaymentInfo()}
						</Col>
						{!['COMPLETED', 'CANCELED'].includes(orderDetail.status) && <Col lg={4} style={{ textAlign: 'right' }}>
							{(orderDetail.paidAmount === 0 || orderDetail.paidAmount < orderDetail.finalAmount) &&
								<Button type={'primary'} onClick={() => setVisible(true)}>{renderTitleButtonPayment()}</Button>}
						</Col>}
					</Row>
				</Fragment>}>
				{renderPaymentInfoDetail()}
				<Collapse
					bordered={false}
					expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
				>
					{renderPaymentHistory()}
				</Collapse>
			</Card>
		</Col>
		<Payment visible={visible}
						 setVisible={setVisible}
						 detail={orderDetail || {}}
						 remainsToPaid={getRemainsToPaid()}
						 setPurchaseDetail={setOrderDetail}
						 paymentHistory={paymentHistory}
						 setPaymentHistory={setPaymentHistory}
						 setRerender={setRerender}
		/>
	</>);
};
